import { useEffect } from 'react';

interface UseHubspotTicketKeyboardNavigationParams {
  onClose: () => void;
  onNavigate: (direction: 'prev' | 'next') => void;
  enabled: boolean;
}

const isEditableTarget = (target: EventTarget | null) =>
  target instanceof HTMLTextAreaElement ||
  target instanceof HTMLSelectElement ||
  (target instanceof HTMLInputElement && target.type !== 'checkbox') ||
  (target instanceof HTMLElement && target.isContentEditable);

export function useHubspotTicketKeyboardNavigation({
  onClose,
  onNavigate,
  enabled,
}: UseHubspotTicketKeyboardNavigationParams) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.defaultPrevented ||
        event.isComposing ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey ||
        isEditableTarget(event.target)
      ) {
        return;
      }

      if (event.key === 'Escape') {
        onClose();
      } else if (
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowUp' ||
        event.key === 'k'
      ) {
        event.preventDefault();
        onNavigate('prev');
      } else if (
        event.key === 'ArrowRight' ||
        event.key === 'ArrowDown' ||
        event.key === 'j'
      ) {
        event.preventDefault();
        onNavigate('next');
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onNavigate, enabled]);
}
